<template>
  <div id="GoTop" v-if="show">
    <img class="robot" src="../assets/img/float/robot.png" alt="robot" />
    <div class="ul-box">
      <div class="li li-1">
        <div class="qw-code">
          <img
            class="qrcode"
            v-lazy="require('../assets/img/float/qrcode.png')"
            alt="企微二维码"
          />
          <span class="label-text">扫码咨询</span>
          <span class="label-text">一对一专业服务</span>
        </div>
      </div>
      <div class="li li-2">
        <div class="call-number">
          <span class="label-text">咨询热线</span>
          <span class="number">400-168-0262</span>
        </div>
      </div>
      <a
        class="call"
        href="https://affim.baidu.com/unique_45460827/chat?siteId=18857849&userId=45460827&siteToken=493919704d5aac29d6432775b0f6fb65"
        target="_blank"
        ><div class="li li-3"></div
      ></a>
    </div>
    <div class="top" @click="GoTop()">
      <img src="../assets/img/float/go-top.png" alt="goTop" />
    </div>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      this.show = true;
    }, 2000);
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
  },
};
</script>
<style lang="scss" scoped>
#GoTop {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 56px;
  position: fixed;
  right: 30px;
  bottom: 16vh;
  z-index: 9999;
  animation: fade-in 2s ease;

  .robot {
    width: 56px;
    height: auto;
  }

  .ul-box {
    width: 56px;
    height: 168px;
    border-radius: 6px;
    background-color: #ffffff;
    margin-top: -14px;
    margin-bottom: 8px;

    .li {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 56px;
      height: 56px;
      border-radius: 6px;
      background-color: #ffffff;
      position: relative;
      cursor: pointer;

      &::before {
        content: "";
        display: block;
      }

      &:hover {
        background-color: #1d56de;
      }
    }

    .li-1 {
      &::before {
        width: 25px;
        height: 20px;
        background: url("../assets/img/float/qw-normal.png") no-repeat;
        background-size: contain;
      }
      &:hover {
        &::before {
          background: url("../assets/img/float/qw-hover.png") no-repeat;
          background-size: contain;
        }

        .qw-code {
          display: flex;
          animation: fade-in 0.8s ease;
        }
      }

      .qw-code {
        position: absolute;
        top: 0;
        right: 68px;
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 184px;
        height: 213px;
        border-radius: 6px;
        background-color: #ffffff;
        letter-spacing: 1px;

        .label-text {
          color: #00094c;
          font-size: 14px;
          font-family: "MiSans-Medium-";
        }

        .qrcode {
          width: 138px;
          height: auto;
          margin-bottom: 5px;
        }
      }
    }
    .li-2 {
      &::before {
        width: 20px;
        height: 26px;
        background: url("../assets/img/float/call-normal.png") no-repeat;
        background-size: contain;
      }
      &:hover {
        &::before {
          background: url("../assets/img/float/call-hover.png") no-repeat;
          background-size: contain;
        }

        .call-number {
          display: flex;
          animation: fade-in 0.8s ease;
        }
      }

      .call-number {
        position: absolute;
        right: 78px;
        display: none;
        flex-direction: column;
        justify-content: center;
        width: 184px;
        height: 56px;
        border-radius: 6px;
        background-color: #ffffff;
        padding-left: 16px;

        .label-text {
          color: #00094c;
          font-size: 12px;
          font-family: "MiSans-Medium-";
        }

        .number {
          color: #1d56de;
          font-family: "MiSans-DemiBold-";
          font-size: 20px;
          line-height: 24px;
          letter-spacing: 1px;
        }

        &::before {
          content: "";
          position: absolute;
          top: calc(50% - 14px);
          right: -10px;
          display: block;
          width: 0;
          height: 0;
          border-top: 14px solid transparent;
          border-bottom: 14px solid transparent;
          border-left: 14px solid #ffffff;
        }
      }
    }
    .li-3 {
      &::before {
        width: 22px;
        height: 22px;
        background: url("../assets/img/float/talk-normal.png") no-repeat;
        background-size: contain;
      }
      &:hover {
        &::before {
          background: url("../assets/img/float/talk-hover.png") no-repeat;
          background-size: contain;
        }
      }
    }
  }

  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 38px;
    border-radius: 6px;
    background-color: #ffffff;
    cursor: pointer;

    img {
      width: 19px;
      height: auto;
    }
  }
}

/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue